import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import CommonCategoryService from "services/CommonCategoryService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllCommonCategory = createAsyncThunk(
  "commonCategory/getAll",
  async (params, { rejectWithValue }) => {
    try {
      const response = await CommonCategoryService.getAll(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const createCommonCategory = createAsyncThunk(
  "commonCategory/create",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CommonCategoryService.create(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateCommonCategory = createAsyncThunk(
  "commonCategory/update",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CommonCategoryService.update(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updatePriorityCommonCategory = createAsyncThunk(
  "commonCategory/updatePriority",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await CommonCategoryService.updatePriority(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const deleteCommonCategory = createAsyncThunk(
  "commonCategory/delete",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;

      const response = await CommonCategoryService.delete(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return id;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  categoryList: [],
};

export const commonCategorySlice = createSlice({
  name: "commonCategory",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCommonCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCommonCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.categoryList = action.payload;
      })
      .addCase(getAllCommonCategory.rejected, (state) => {
        state.loading = false;
      })

      .addCase(createCommonCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCommonCategory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createCommonCategory.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateCommonCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCommonCategory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateCommonCategory.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updatePriorityCommonCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePriorityCommonCategory.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePriorityCommonCategory.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteCommonCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCommonCategory.fulfilled, (state, action) => {
        state.loading = false;

        state.categoryList = state.categoryList.filter(
          (x) => x.id !== action.payload
        );
      })
      .addCase(deleteCommonCategory.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = commonCategorySlice.actions;

export default commonCategorySlice.reducer;